import { FuelButton, FuelTypography } from '@frete.com/fuel-react'
import styled from 'styled-components'

export const Subtitle = styled(FuelTypography).attrs({ size: 'body-sm', color: 'neutral-default', weight: 'medium' })`
  p {
    padding-top: 8px;
    padding-bottom: 32px;
  }
`

export const Title = styled(FuelTypography).attrs({ size: 'heading-sm', color: 'neutral-strong', weight: 'bold' })``

export const Cellphone = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 24px;
  padding-top: 24px;

  :not(:last-child) {
    border-bottom: 1px solid #dddfe4;
  }
`

export const ConfirmButton = styled(FuelButton).attrs({
  size: 'large',
  fullWidth: true,
})`
  margin-top: ${({ theme }) => theme.spacing.km10};
`
